import { render, staticRenderFns } from "./RActivitiesPie.vue?vue&type=template&id=a1fffd8e&scoped=true"
import script from "./RActivitiesPie.vue?vue&type=script&lang=js"
export * from "./RActivitiesPie.vue?vue&type=script&lang=js"
import style0 from "./RActivitiesPie.vue?vue&type=style&index=0&id=a1fffd8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fffd8e",
  null
  
)

export default component.exports